/**
 * @prettier
 */

import createBehavior from '@js/functions/createBehavior.js';

const cardVideoBehavior = createBehavior(
  'card-video',
  {
    bindUI() {
      this.ui = {};
      this.ui.link = this.getChild('link');
    },
    bindEvents() {
      this.ui.link.addEventListener('click', this.linkClickHandler, false);
      // Flickity intercepts touch clicks on non-selected cells — carousel re-dispatches this
      this.node.addEventListener('carousel:static-click', this.onCarouselStaticClick, false);
    },
    openModal() {
      // Guard against double-fire: native click + Flickity staticClick can both trigger.
      if (this._opening) return;
      this._opening = true;
      setTimeout(() => { this._opening = false; }, 300);

      const videos = [];
      let currentIndex = 0;

      const carouselItem = this.node.closest('.carousel__item');
      if (carouselItem) {
        const list = carouselItem.parentNode;
        const siblings = list.querySelectorAll('[data-behavior="card-video"]');

        siblings.forEach((sibling, i) => {
          try {
            const videoData = JSON.parse(sibling.dataset.video);
            videoData.caption = sibling.dataset.caption || '';
            videos.push(videoData);
            if (sibling === this.node) {
              currentIndex = i;
            }
          } catch (err) {
            // malformed data-video, skip
          }
        });
      }

      // Fallback: only this card
      if (!videos.length) {
        try {
          const videoData = JSON.parse(this.node.dataset.video);
          videoData.caption = this.node.dataset.caption || '';
          videos.push(videoData);
        } catch (err) {
          // nothing to play
        }
      }

      document.dispatchEvent(
        new CustomEvent('card-video-shorts:open', {
          detail: {
            videos,
            index: currentIndex,
          },
        }),
      );
    },
    linkClickHandler(e) {
      e.preventDefault();
      this.openModal();
    },
    onCarouselStaticClick() {
      this.openModal();
    },
  },
  {
    init() {
      this.bindUI();
      this.bindEvents();
    },
    destroy() {},
  },
);

export default cardVideoBehavior;
